export default (time) => {
  if (time.indexOf(':') < 0) {
    return time;
  }

  const split = time.split(':');

  return `${split[0]}:${split[1]}`;
};
